import React, { Component } from "react";
import styles from "./styles.scss";
import CSSModules from "react-css-modules";
import PropTypes from "prop-types";
import { actions } from "./redux";
import { connect } from "react-redux";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { TreeMap } from "../../utils";

/*

Use:


*/

class Select extends Component {
   static defaultProps = {
      containerClass: "",
      textClass: "",
      nameProp: "name",
      dropdownClass: "",
      zIndex: 1,
      actions: new TreeMap()
   };
   static propTypes = {
      params: PropTypes.object,
      value: PropTypes.object,
      classes: PropTypes.object //style overrides
   };

   componentWillMount() {
      this.props.registerSelect(this.props.selectId, this.props.actions);
   }

   componentWillReceiveProps(nextProps) {
      if (nextProps.actions !== this.props.actions) {
         this.props.registerSelect(this.props.selectId, nextProps.actions);
      }
   }
   filter() {
      const rtn = this.props.actions.filter(x => x.condition === undefined || x.condition());
      return rtn;
   }

   renderChildren(parent, level) {
      if (parent._tree.children.length > 0) {
         const children = this.props.map.Where(x => x._tree.parent === parent._tree.own);

         return children.map((x, i) => {
            const selected = this.props.value && this.props.value._tree && this.props.value._tree.own === x._tree.own;
            const isLast = i === children.length - 1;
            return (
                  <div styleName="node-container" key={i}>
                        <div styleName="grey-line" />
                        <div
                              styleName="node"
                              open={x.isOpen}
                              last={isLast.toString()}
                              key={i}
                              level={level}
                              onClick={e => {
                                    e.stopPropagation();
                                    if(x._tree.children.length === 0) {
                                          this.props.onChange(x);
                                          this.props.toggleMenu(this.props.selectId);
                                    }
                                    this.props.toggleOpenNode(this.props.selectId, x, x.children.length === 0);
                              }}
                        >
                              <div styleName="node-content" isselected={(!!selected).toString()}>
                              <div styleName="node-text" style={{ paddingLeft: level * 15 }}>
                                    {x[this.props.nameProp]}
                              </div>
                              {x._tree.children.length > 0 && (
                                    <div
                                    styleName="openhandle"
                                    onClick={e => {
                                          e.stopPropagation();
                                          this.props.toggleOpenNode(this.props.selectId, x, false);
                                    }}
                                    >
                                    {x.isOpen && <KeyboardArrowUp />}
                                    {!x.isOpen && <KeyboardArrowDown />}
                                    </div>
                              )}
                              </div>
                              {x.isOpen && this.renderChildren(x, level + 1)}
                        </div>
                  </div>
            );
         });
      } else {
         return null;
      }
   }

   render() {
      return (
         <React.Fragment>
            {this.props.hasSelect &&
               this.props.isOpen && (
                  <div
                     styleName="close-area"
                     style={{ zIndex: this.props.zIndex }}
                     onClick={() => this.props.toggleMenu(this.props.selectId)}
                  />
               )}
            <div
               styleName={`_container ${this.props.containerClass}`}
               onClick={() => this.props.toggleMenu(this.props.selectId)}
            >
               <p styleName={`_text ${this.props.textClass}`}>{(this.props.value || {})[this.props.nameProp]}</p>
               {this.props.isOpen && <KeyboardArrowUp />}
               {!this.props.isOpen && <KeyboardArrowDown />}

               {this.props.hasSelect && (
                  <div
                     styleName={`_dropdown-container ${this.props.dropdownClass}`}
                     open={this.props.isOpen}
                     style={{ zIndex: this.props.zIndex + 1 }}
                  >
                     {this.props.map &&
                        this.props.map.Roots.map((x, i) => {
                           const selected =
                              this.props.value && this.props.value._tree && this.props.value._tree.own === x._tree.own;
                           return (
                              <div
                                 level="0"
                                 open={x.isOpen}
                                 styleName="node root"
                                 key={i}
                                 onClick={e => {
                                    e.stopPropagation();
                                    this.props.onChange(x);
                                 }}
                              >
                                 <div styleName="node-content" isselected={(!!selected).toString()} 
                                    onClick={e => {
                                          e.stopPropagation();
                                          if(x._tree.children.length === 0) {
                                                this.props.onChange(x);
                                                this.props.toggleMenu(this.props.selectId);
                                          }
                                          this.props.toggleOpenNode(this.props.selectId, x, x._tree.children.length === 0);
                                    }}>
                                    <div styleName="node-text">{x[this.props.nameProp]}</div>
                                    {x._tree.children.length > 0 && (
                                       <div
                                          styleName="openhandle"
                                       >
                                          {x.isOpen && <KeyboardArrowUp />}
                                          {!x.isOpen && <KeyboardArrowDown />}
                                       </div>
                                    )}
                                 </div>
                                 {x.isOpen && this.renderChildren(x, 1)}
                              </div>
                           );
                        })}
                  </div>
               )}
            </div>
         </React.Fragment>
      );
   }
}

//do this to merge classes
export default class extends Component {
   constructor(props) {
      super(props);
      this.state = {
         wrapped: null
      };
   }

   componentWillMount() {
      if (this.props.selectId === undefined) {
         throw "TreeSelect must have 'selectId' prop set.";
      }

      const bindAction = dispatch => {
         return {
            registerSelect: (id, map) => dispatch(actions.registerSelect(id, map)),
            toggleOpenNode: (id, node, hide) => dispatch(actions.toggleOpenNode(id, node, hide)),
            toggleMenu: id => dispatch(actions.toggleMenu(id))
         };
      };

      //only map the props for this select id
      const mapStateToProps = state => {
         const select = state.treeSelect.selects[this.props.selectId];
         const { selects, ...rest } = state.treeSelect;
         return {
            ...rest,
            ...select,
            hasSelect: !!select
         };
      };

      this.setState({
         wrapped: connect(
            mapStateToProps,
            bindAction
         )(
            CSSModules(
               Select,
               { ...styles, ...this.props.classes },
               {
                  allowMultiple: true
               }
            )
         )
      });
   }

   render() {
      const Elem = this.state.wrapped;
      return <Elem {...this.props} />;
   }
}



// WEBPACK FOOTER //
// ./src/components/TreeSelect/TreeSelect.js